export interface IcNavigationOpenEventDetail {
  source: HTMLElement;
}

export interface IcNavigationExpandEventDetail {
  expanded: boolean;
}
